import { Button, Input, Select, Switch } from "antd";
import { useEffect, useState } from "react";
import { ImageUpload } from "./ImageUpload";
import { fetcher } from "../../utils/helper";
import { toast } from "react-toastify";

export const EditServices = ({
  data,
  setShowSkeleton,
  setEditModalOpen,
  portals,
}) => {
  const settingsData = JSON.parse(sessionStorage.getItem("settings"));
  const [portalOption, setPortalOption] = useState([]);
  const [serviceData, setServiceData] = useState({
    title: data.title,
    description: data.description,
    image: data.file_location,
    image_name: data.image,
    // form:data.form.id ,
    service_categorie_id: data?.service_categorie?.id,
    portal_credentials_id: data?.portal_credentials_id,
  });
  const [categoryListig, setCategoryListing] = useState([]);
  const [portalEnable, setPortalEnable] = useState(false);

  function startsWithHttp(url) {
    return (
      url.toLowerCase().startsWith("http://") ||
      url.toLowerCase().startsWith("https://")
    );
  }

  useEffect(() => {
    if(data?.portal_credentials_id != null) {
      setPortalEnable(true);
    }
  }, [])

  const getAllCategories = async () => {
    let method = "GET";
    let url = "governify/admin/serviceCategories";

    try {
      const response = await fetcher(url, method);
      if (response.status) {
        setCategoryListing(
          response.response.map((item) => {
            return { label: item.title, value: item.id };
          })
        );
        setShowSkeleton(false);
      }
    } catch (err) {
      throw new Error("Network response was not ok ", err);
    }
  };

  const handleCreateServices = async () => {
    let method = "PUT";
    let url = `governify/admin/serviceRequests/${data.id}`;
    let payload = {
      ...serviceData,
      portal_credentials_id:
      !portalEnable ? '' : serviceData.portal_credentials_id == null
          ? ""
          : serviceData.portal_credentials_id,
    };
    payload.image_name = startsWithHttp(serviceData.image)
      ? ""
      : serviceData.image_name;
    payload.image = startsWithHttp(serviceData.image) ? "" : serviceData.image;

    try {
      const response = await fetcher(url, method, JSON.stringify(payload));
      if (response.status) {
        setShowSkeleton(true);
        setEditModalOpen(false);
        toast.success("Service Updated Successfully.");
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      toast.error("Error");
      console.log(err, "error");
    }
  };

  const handleTitleChange = (e) => {
    setServiceData({ ...serviceData, title: e.target.value });
  };

  const handleDescriptionChange = (e) => {
    setServiceData({ ...serviceData, description: e.target.value });
  };

  const handleFileSelect = (data, imageName) => {
    setServiceData({ ...serviceData, image: data, image_name: imageName });
  };

  const handleCategoryChange = (e) => {
    setServiceData({ ...serviceData, service_categorie_id: e });
  };

  const handlePortalChange = (value) => {
    setServiceData({ ...serviceData, portal_credentials_id: value });
  };

  useEffect(() => {
    if (portals.length) {
      let option = [];
      portals.map((item) => {
        option.push({
          label: (
            <div className="countryOption ff-ws">
              <span
                dangerouslySetInnerHTML={{
                  __html: `<img width="20px" src='${item.file_location}' />`,
                }}
                className="tw-max-w-[20px] tw-h-[20px]"
              ></span>
              {" " + item.title}
            </div>
          ),
          value: item.id,
        });
      });
      setPortalOption(option);
    }
  }, [portals]);

  useEffect(() => {
    getAllCategories();
  }, []);

  return (
    <>
      <div style={{ maxWidth: "550px", width: "100%", marginTop: "25px" }}>
        <div>
          <div className="text-white" style={{ backgroundColor: "#59C080" }}>
            <p className="p-2 m-0 fs-5">
              <strong>Edit Services</strong>
            </p>
          </div>
          <div
            className="form_wrapper border border-success p-4 primary-shadow"
            style={{ height: "600px", overflowY: "auto" }}
          >
            <div>
              <ImageUpload
                onFileSelect={handleFileSelect}
                imageName={serviceData.image_name}
                imageUrl={serviceData.image}
              />
            </div>
            <Input
              placeholder="Service Title"
              className="mt-30"
              onChange={handleTitleChange}
              value={serviceData.title}
              addonBefore="Title"
              disabled={true}
            />
            <Input
              placeholder="Service description"
              className="mt-10"
              onChange={handleDescriptionChange}
              value={serviceData.description}
              addonBefore="Description"
            />

            <div className="mt-10">
              <Select
                showSearch
                placeholder="Select Category"
                style={{ width: "100%" }}
                popupMatchSelectWidth={false}
                placement="bottomLeft"
                onChange={handleCategoryChange}
                options={categoryListig}
                value={serviceData.service_categorie_id}
              />
            </div>
            <div className="mt-10">
              <Select
                showSearch
                disabled={!portalEnable}
                placeholder="Select Portal (Optional)"
                style={{ width: "100%" }}
                popupMatchSelectWidth={false}
                placement="bottomLeft"
                onChange={handlePortalChange}
                options={portalOption}
                value={serviceData.portal_credentials_id}
              />
            </div>
            <div className="mt-10 d-flex align-items-center" style={{gap: '5px'}}>
              <span>Enable/Disable Portal</span>
              <Switch checked={portalEnable} onChange={() => setPortalEnable(!portalEnable)} />
            </div>
            <div
              style={{ display: "flex", justifyContent: "center" }}
              className="mt-60"
            >
              <Button
                className="mt-10"
                style={{
                  background: settingsData.button_bg,
                  color: "#fff",
                  border: "none",
                }}
                onClick={handleCreateServices}
              >
                Update
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
